import { z } from "zod";

export const durationSchema = z.union([
  z.literal("monthly"),
  z.literal("yearly"),
]);

export const planSchema = z.union([
  z.literal("free"),
  z.literal("beginning"),
  z.literal("basic"),
  z.literal("premium"),
]);

export const pricingInfoSchema = z.object({
  fee: z.number().nullish(),
  billingPeriod: z.string().nullish(),
  currency: z.string().nullish(),
  description: z.string().nullish(),
});

const itemStyle = z.union([z.literal("outlined"), z.literal("filled")]);
const baseItemSchema = z.object({
  name: z.string(),
  style: itemStyle,
});

type ItemProps = z.infer<typeof baseItemSchema> & {
  nestedContent?: ItemProps[];
};

// 
export const contentSchema: z.ZodType<ItemProps> = baseItemSchema.extend({
  nestedContent: z.lazy(() => contentSchema.array().optional()),
});

export const planInfoSchema = z.object({
  plan: planSchema.optional(),
  name: z.string(),
  pricing: pricingInfoSchema,
  limitDesc: z.string().optional(),
  content: z.array(contentSchema).optional(),
  disabled: z.boolean().optional(),
});

export const tiersSchema = z.record(durationSchema, planInfoSchema.array());

export type Plan = z.infer<typeof planSchema>;
export type PricingInfo = z.infer<typeof pricingInfoSchema>;
export type PlanContentItem = z.infer<typeof contentSchema>;
export type PlanInfo = z.infer<typeof planInfoSchema>;
export type TiersData = z.infer<typeof tiersSchema>;
